export const SELECT_USER = 'SELECT_USER';
export const LIST_USER = 'LIST_USER';
export const LIST_ROLES = 'LIST_ROLES';